import React from 'react';

import { CreditOverviewContext } from '@f/context';

import { useInterval } from './useInterval';

export function useCreditOverview(refreshInterval = 30 * 1000) {
  const { creditOverview, updateCreditOverview } = React.useContext(CreditOverviewContext);

  React.useEffect(() => {
    void updateCreditOverview();
  }, []);

  useInterval(() => {
    void updateCreditOverview();
  }, refreshInterval);

  return creditOverview;
}
